import { useMutation, useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import { updateProdCodeType } from "../../../../../actions/Utilities/ProducerCodeType";
import { toast } from "../../../../../components/toastNotification";
import { editStateProdCodetype } from "../atoms/atoms";

const useUpdateProdCodeType = () => {
  const queryClient = useQueryClient();
  const [, setEditState] = useRecoilState(editStateProdCodetype);

  const { mutate } = useMutation(
    (prodType) => updateProdCodeType({ ...prodType }),
    {
      onSuccess: (res) => {
        if (res.data === "duplicate") {
          toast.fire(
            "Failed",
            "Another Producer Code Type already has the same information",
            "error"
          );
        } else if (res.status === 201) {
          setEditState(false);
          queryClient.invalidateQueries("GetProducerCodeType");
          toast.fire(
            "Success",
            "Producer Code Type updated successfully",
            "success"
          );
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot update Producer Code Type",
            "error"
          );
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          toast.fire(
            "Success",
            "Producer Code Type updated successfully, but " +
              error.response.data.message,
            "warning"
          );
          queryClient.invalidateQueries("GetProducerCodeType");
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot add new Producer Code Type",
            "error"
          );
        }
      },
    }
  );
  return mutate;
};
export default useUpdateProdCodeType;
